import { get as getCookie, remove as removeCookie, setOnce as setCookie } from 'js/lib/cookie';

import { LOGGED_OUT_ONBOARDING_COOKIE_NAME } from 'bundles/onboarding-common/constants';

const setHasSeenLoggedOutOnboarding = () => {
  setCookie(LOGGED_OUT_ONBOARDING_COOKIE_NAME, 'true', {});
};

const getHasSeenLoggedOutOnboarding = () => {
  return getCookie(LOGGED_OUT_ONBOARDING_COOKIE_NAME) === 'true';
};

const removeLoggedOutOnboardingCookie = () => {
  removeCookie(LOGGED_OUT_ONBOARDING_COOKIE_NAME);
};

export { setHasSeenLoggedOutOnboarding, getHasSeenLoggedOutOnboarding, removeLoggedOutOnboardingCookie };
